import {type RouteComponentProps} from 'react-router-dom';

import {deserializeFieldNames} from 'nutshell-core/entities/deserialize-fields';
import type {FilterObject} from 'nutshell-core/types';

import {
    DEFAULT_FIELDS_ENGAGEMENT_BAR_LEADS,
    DEFAULT_SORT_FIELD_ENGAGEMENT_BAR_LEADS,
} from '../../reports/report-constants';
import type {ReportURLParams} from '../../reports/report-types';

import {EngagementBarLeadsListContainer} from './engagement-bar-leads-list-container';
import {EngagementLeadsBanner} from './engagement-leads-banner';

const EMPTY_FILTERS: FilterObject[] = [];

interface Props extends RouteComponentProps<{page?: string; id?: string}> {
    activeFilters: FilterObject[];
    onParamChange: (params: any, replace: boolean) => void;
    urlParams: ReportURLParams<'leads'>;
}

export function EngagementBarLeads(props: Props) {
    const listParams = props.urlParams?.list;

    const selectedFields = listParams?.fields?.leads
        ? deserializeFieldNames(listParams?.fields?.leads)
        : [DEFAULT_FIELDS_ENGAGEMENT_BAR_LEADS];

    const selectedPage =
        listParams?.page && Number(listParams?.page) ? Number(listParams?.page) : 1;

    const searchQuery = props.urlParams?.q || undefined;

    return (
        <div id='engagement-bar-leads-list'>
            <EngagementLeadsBanner />
            <EngagementBarLeadsListContainer
                filters={props.activeFilters || EMPTY_FILTERS}
                selectedPage={selectedPage}
                selectedSortField={listParams?.sort || DEFAULT_SORT_FIELD_ENGAGEMENT_BAR_LEADS}
                selectedFields={selectedFields}
                searchQuery={searchQuery}
                onParamChange={props.onParamChange}
            />
        </div>
    );
}
